import { Video } from '../types/tutorials.types';

/**
 * Video tutorials database
 * YouTube ID is extracted from the URL: https://youtu.be/{youtubeId}
 */
export const VIDEOS: Video[] = [
  {
    id: 'video-001',
    title: 'Fidelización de clientes y membresías con MedioPunto',
    description: 'En este video, te enseñamos como con MedioPunto, puedes crear sistemas de membresías y fidelizar a tus clientes. Con este nuevo sistema, puedes tener control sobre quienes son tus clientes y acercarte más a ellos, construyendo una comunidad de beneficios que cree raíces más sólidas para el futuro de tu negocio.',
    youtubeId: 'mGToi-cGd2s',
    duration: '8:11',
    tags: ['clientes'],
    subTags: ['membresias', 'fidelizacion'],
    isNew: true,
    publishedDate: '2025-11-02',
    views: 0
  },
  {
    id: 'video-002',
    title: 'Cierre de sesión y arqueo de caja',
    description: 'En este video te enseñare como hacer el cierre del día, y como realizar un arqueo de caja, para que todos tus números estén en orden!',
    youtubeId: '41IqCVeWNeI',
    duration: '5:55',
    tags: ['sesiones'],
    subTags: ['cerrar-sesion', 'arqueo-caja'],
    isNew: true,
    publishedDate: '2025-11-02',
    views: 0
  },
  {
    id: 'video-003',
    title: 'Nuevo modo hoster y mesa virtual para control total en MedioPunto',
    description: 'Con nuestro nuevo sistema de modo hoster y mesa virtual, puedes atender a tus clientes de manera ágil, sin sacar los ojos de donde importa, y sin la necesidad de darte vueltas.',
    youtubeId: 'fJW70u1S9LQ',
    duration: '4:53',
    tags: ['pedidos', 'configuracion'],
    subTags: ['modo-hoster'],
    isNew: false,
    publishedDate: '2025-10-28',
    views: 4
  },
  {
    id: 'video-004',
    title: 'Cómo mover productos entre mesas con MedioPunto',
    description: 'En este video, te enseñamos cómo puedes mover productos de una mesa a otra en caso de errores, para evitar eliminaciones, y con mínimos pasos.',
    youtubeId: 'HKw1Q3SA7Yc',
    duration: '1:41',
    tags: ['pedidos'],
    subTags: ['mover-productos', 'editar-pedido'],
    isNew: false,
    publishedDate: '2025-10-28',
    views: 1
  },
  {
    id: 'video-005',
    title: 'Cómo juntar mesas para grupos grandes en tu restaurant con MedioPunto',
    description: 'En este video, te mostramos como con MedioPunto, puedes recibir mesas grandes y atenderlos sin complicaciones.',
    youtubeId: 'yIHiXhl-8d8',
    duration: '1:30',
    tags: ['pedidos'],
    subTags: ['juntar-mesas'],
    isNew: false,
    publishedDate: '2025-10-28',
    views: 1
  },
  {
    id: 'video-006',
    title: 'Cómo separar la cuenta entre comensales con MedioPunto',
    description: 'Aprende a dividir la cuenta de manera fácil y rápida entre diferentes comensales de una misma mesa.',
    youtubeId: 'rtRZH0nDQfs',
    duration: '3:21',
    tags: ['pedidos', 'pagos'],
    subTags: ['separar-cuenta'],
    isNew: false,
    publishedDate: '2025-10-28',
    views: 6
  },
  {
    id: 'video-007',
    title: 'Inicio de sesión y sistema de turnos',
    description: 'En este video, te enseñaremos como iniciar una sesión, y como crear más de un turno dentro de esa sesión. El sistema de turnos te permite separar de manera ordenada las ventas dentro de un mismo día, y evitar errores a la hora de hacer la cuadratura entre cambios de turno.',
    youtubeId: 'O6HHgG6ZwYw',
    duration: '5:34',
    tags: ['sesiones', 'turnos'],
    subTags: ['iniciar-sesion', 'crear-turno', 'cuadratura-turno'],
    isNew: false,
    publishedDate: '2025-10-19',
    views: 20
  },
  {
    id: 'video-008',
    title: 'Configuración de salones y mesas',
    description: 'Aprende a configurar tus salones y mesas en MedioPunto. En este video te mostramos cómo crear nuevos salones, añadir mesas, configurar su capacidad, usar etiquetas personalizadas, y organizar el espacio de tu restaurante de manera eficiente. También aprenderás a mover objetos de referencia y gestionar la activación de salones.',
    youtubeId: '071hC-tixQ4',
    duration: '2:44',
    tags: ['configuracion'],
    subTags: ['config-mesas'],
    isNew: true,
    publishedDate: '2025-11-16',
    views: 0
  },
  {
    id: 'video-009',
    title: 'Configuración de software de impresión',
    description: 'Aprende a configurar el software de impresión de MedioPunto para personalizar tus comandas y recibos. En este video te mostramos cómo acceder a la configuración desde el ícono naranja, personalizar el orden y contenido de la información en las comandas (hora, mesa, mensajes), editar el formato de los recibos y precuentas, y ajustar la alineación y tamaño del texto según tus preferencias.',
    youtubeId: 'sHCTLizB_Gc',
    duration: '1:12',
    tags: ['impresion', 'configuracion'],
    subTags: ['config-impresion', 'imprimir-recibos'],
    isNew: true,
    publishedDate: '2025-11-16',
    views: 0
  },
  {
    id: 'video-010',
    title: 'Configuración de Linktree (Mi punto digital)',
    description: 'Descubre cómo configurar tu Mi Punto Digital, el Linktree de MedioPunto. En este video aprenderás a editar los módulos de tu página: descripción del local, página web, WhatsApp, ubicación en Google Maps, sistema de reservas, promociones vigentes, y menú integrado. También te mostramos cómo compartir tu link en redes sociales y generar códigos QR para imprimir y colocar en las mesas de tu restaurante. El menú integrado se actualiza automáticamente cuando cambias precios en el sistema.',
    youtubeId: 'hwtEFe4_okg',
    duration: '1:27',
    tags: ['clientes', 'configuracion', 'menus', 'marketing-digital'],
    subTags: ['gestion-clientes', 'punto-digital', 'config-general', 'presencia-web', 'redes-sociales', 'qr-codes'],
    isNew: true,
    publishedDate: '2025-11-16',
    views: 0
  }
];
